import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/elevator/buttons';
const serviceName = "ButtonContent-Service: ";

export default class ButtonContentService {

    static async putToAPI(buttonContent, successF, errorF) {
        await WrapperService.put(API_URL + '/' + buttonContent.id, buttonContent, serviceName, successF, errorF);
    }

    static async postToAPI(buttonContent, successF, errorF) {
        await WrapperService.post(API_URL, buttonContent, serviceName, successF, errorF);
    }

    static async readFromAPI(elevatorId, successF, errorF) {
        await WrapperService.get(API_URL + '/' + elevatorId, null, serviceName, successF, errorF);
    }

    static async getButtonCarouselContents(successF, errorF) {
        await WrapperService.get(API_URL + '/buttons', null, serviceName, successF, errorF);
    }
}